export default class GraphDataProvider {
    constructor() {
        this.cachedData = {};
    }

    /**
     * @param {Date} date
     * @return {[]|*}
     */
    getData(date) {
        let dateStr = date.toDateString();

        if (this.cachedData[dateStr]) {
            return this.cachedData[dateStr];
        }

        let data = [];
        for (let employeeType of Object.keys(EMPLOYEE_TYPES)) {
            let {color, scaling} = EMPLOYEE_TYPES[employeeType];
            let employeeData = [];
            for (let i = 0; i < 12; i++) {
                employeeData.push(Math.round(((Math.random() * 0.3) + 0.7) * scaling[i] * 35));
            }

            data.push({
                label: employeeType,
                backgroundColor: color,
                data: employeeData,
            });
        }

        this.cachedData[dateStr] = data;

        return data;
    }
}

const EMPLOYEE_TRAINEE = 'Trainee';
const EMPLOYEE_STAFF = 'Staff';
const EMPLOYEE_SUPERVISOR = 'Supervisor';
const EMPLOYEE_MANAGER = 'Manager';

const EMPLOYEE_TYPES = {
    [EMPLOYEE_TRAINEE]: {
        color: "#DE173E",
        scaling: [
            0,
            0,
            0,
            0.5,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
        ],
    },
    [EMPLOYEE_STAFF]: {
        color: "#434345",
        scaling: [
            0,
            0,
            0,
            0,
            0.7,
            0.8,
            1.3,
            1.4,
            0,
            0,
            0,
            0.5,
        ],
    },
    [EMPLOYEE_SUPERVISOR]: {
        color: "#F47832",
        scaling: [
            0.8,
            0.5,
            0.4,
            0.3,
            0.4,
            0,
            0,
            0,
            1.5,
            1.5,
            1.4,
            0.2,
        ],
    },
    [EMPLOYEE_MANAGER]: {
        color: "#625E9B",
        scaling: [
            0,
            0,
            0.2,
            0,
            0,
            0.6,
            0.6,
            0.7,
            0.8,
            0.8,
            0.5,
            0,
        ],
    },
};
